import "./NewCopyTradeCM.css";
import ExchangeConnection from "../NewCopyTrade/ExchangeConnection/ExchangeConnection";
import React from "react";
import HowItWorks from "./HowItWorks/HowItWorks";
import CustomSwitch from "../CommonComponents/CustomSwitch/CustomSwitch";
import AutoShareCM from "../NewCopyTrade/AutoShare/AutoShareCM";

const NewCopyTradeCM = () => {
  return (
    <div className="NewCopyTradePageCM">
      <div className="container-fluid g-0">
        <div className="tradingMember">
          <ExchangeConnection 
            title="Copy Trading"
            subtitle="No connection, no copy trading."
            customClass="exchangeMember"
            ipcustomClass="memberCopyTrade"
            buttonVariant="black"
          />
        </div>

        <div className="tradingUpdates">
          <AutoShareCM 
            title="Copy Trading Updates"
            subtitle="Where would you like to receive updates?"
            customClass="autoSectionMember"
          />
            {/* <h6 className="fs-14">How often would you like to receive updates?</h6>
            <div className="copyTradelandingPageReview fs-14">
              <div className="d-flex flex-column justify-content-center gap-3">
                <p>Daily</p>
                <CustomSwitch />
              </div>
              <div className="d-flex flex-column justify-content-center gap-3">
                <p>Weekly</p>
                <CustomSwitch />
              </div>
              <div className="d-flex flex-column justify-content-center gap-3">
                <p>Monthly</p>
                <CustomSwitch />
              </div>
            </div> */}
        </div>
        {/* <HowItWorks /> */}
      </div>
    </div>
  );
};

export default NewCopyTradeCM;
